"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_NAVIGATE_HEADER = exports.ACTION_NAVIGATE_GOTO_OLD_ADMIN = exports.ACTION_UTILS_COPY_TO_CLIPBOARD = exports.ACTION_STORE_INFO = exports.ACTION_AUTH_SESSION_TOKEN = exports.ACTION_NAVIGATE_SYNC = exports.ACTION_NAVIGATE_PATHNAME = exports.ACTION_NAVIGATE_GOTO = exports.ACTION_NAVIGATE_BACK = exports.ACTION_NAVIGATE_EXIT = exports.ACTION_CONNECTED = exports.ACTION_READY = void 0;
exports.ACTION_READY = "app/ready";
exports.ACTION_CONNECTED = "app/connected";
exports.ACTION_NAVIGATE_EXIT = "app/navigate/exit";
exports.ACTION_NAVIGATE_BACK = "app/navigate/back";
exports.ACTION_NAVIGATE_GOTO = "app/navigate/goTo";
exports.ACTION_NAVIGATE_PATHNAME = "app/navigate/pathname";
exports.ACTION_NAVIGATE_SYNC = "app/navigate/sync";
exports.ACTION_AUTH_SESSION_TOKEN = "app/auth/sessionToken";
exports.ACTION_STORE_INFO = "app/store/info";
exports.ACTION_UTILS_COPY_TO_CLIPBOARD = "app/utils/copyToClipboard";
exports.ACTION_NAVIGATE_GOTO_OLD_ADMIN = "app/navigate/goToOldAdmin";
exports.ACTION_NAVIGATE_HEADER = "app/navigate/header";
